module.exports = __webpack_public_path__ + "static/cgilogo-e5ec0558d757b0a57a6cef2da52754af.png";